<template>
  <div class="tab-with-icons">
    <div :class="['tab-container__nav', navClass]">
      <ul class="tab-container__nav__items">
        <li
          v-for="(tab, tabIndex) in tabsIndexed"
          :key="tab.key"
          class="tab-container__nav__item"
        >
          <!-- {{ tab }} -->
          <button
            type="button"
            @click="
              () => {
                if (!showNavIndices || tabsVisited.indexOf(tab.key) != -1)
                  showTab(tab.key);
              }
            "
            :class="
              Object.assign({}, buttonClass, {
                active: tab.key == activeTab,
                visited: tabsVisited.indexOf(tab.key) != -1,
              })
            "
          >
            <span
              v-if="showNavIndices && tab.key == 'pictures'"
              class="tab-container__nav__item__icon"
            >
              <div class="d-flex flex-column align-items-center w-100">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab ? 'file.svg' : 'file-black.svg'
                    )
                  "
                  width="30"
                  height="30"
                />
                <!-- :src="
                    getIconSrc(
                      tab.key === activeTab ||
                        tabsVisited.indexOf(tab.key) != -1
                        ? 'file.svg'
                        : 'file-black.svg'
                    )
                  " -->
                <p>{{ tabIndex + 1 }}. {{ tab.label }}</p>
              </div>
              <span class="tab-chevron-right">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'chevron-right-green.svg'
                        : 'chevron-right.svg'
                    )
                  "
                />
              </span>
            </span>
            <span
              v-if="showNavIndices && tab.key == 'common'"
              class="tab-container__nav__item__icon"
            >
              <div class="d-flex flex-column align-items-center w-100">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'file.svg'
                        : 'file-black.svg'
                    )
                  "
                  width="30"
                  height="30"
                />
                <p>{{ tabIndex + 1 }}. {{ tab.label }}</p>
              </div>
              <span class="tab-chevron-right">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'chevron-right-green.svg'
                        : 'chevron-right.svg'
                    )
                  "
                />
              </span>
            </span>
            <span
              v-if="showNavIndices && tab.key == 'code'"
              class="tab-container__nav__item__icon"
            >
              <div class="d-flex flex-column align-items-center w-100">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'qr-icon-green.svg'
                        : 'qr-icon.svg'
                    )
                  "
                  width="30"
                  height="30"
                />
                <p>{{ tabIndex + 1 }}. {{ tab.label }}</p>
              </div>
              <span class="tab-chevron-right">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'chevron-right-green.svg'
                        : 'chevron-right.svg'
                    )
                  "
                />
              </span>
            </span>
            <span
              v-if="showNavIndices && tab.key == 'dates'"
              class="tab-container__nav__item__icon"
            >
              <div class="d-flex flex-column align-items-center w-100">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'calendar-green.svg'
                        : 'calendar.svg'
                    )
                  "
                  width="30"
                  height="30"
                />
                <p>{{ tabIndex + 1 }}. {{ tab.label }}</p>
              </div>
              <span class="tab-chevron-right">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'chevron-right-green.svg'
                        : 'chevron-right.svg'
                    )
                  "
                />
              </span>
            </span>
            <span
              v-if="showNavIndices && tab.key == 'checks'"
              class="tab-container__nav__item__icon"
            >
              <div class="d-flex flex-column align-items-center w-100">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'check-square-green.svg'
                        : 'check-square.svg'
                    )
                  "
                  width="30"
                  height="30"
                />
                <p>{{ tabIndex + 1 }}. {{ tab.label }}</p>
              </div>
              <span class="tab-chevron-right">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'chevron-right-green.svg'
                        : 'chevron-right.svg'
                    )
                  "
                />
              </span>
            </span>
            <span
              v-if="showNavIndices && tab.key == 'overview'"
              class="tab-container__nav__item__icon"
            >
              <div class="d-flex flex-column align-items-center w-100">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'list-item-green.svg'
                        : 'list-item.svg'
                    )
                  "
                  width="30"
                  height="30"
                />
                <p>{{ tabIndex + 1 }}. {{ tab.label }}</p>
              </div>
              <span class="tab-chevron-right">
                <img
                  :src="
                    getIconSrc(
                      tab.key === activeTab 
                        ? 'chevron-right-green.svg'
                        : 'chevron-right.svg'
                    )
                  "
                />
              </span>
              <!-- <span>
                <img :src="icon('chevron-right.svg')" />
              </span> -->
            </span>
            <!-- <span
              v-if="showNavIndices"
              class="tab-tab-container__nav__item__icon"
              >{{ tabIndex + 1 }}</span
            > -->
            <!-- <span class="tab-container__nav__item__label">{{ tab.label }}</span> -->
          </button>
        </li>
      </ul>
    </div>

    <div
      :class="`tab-container__body tab-container__body--${activeTab}`"
      :key="activeTab"
    >
      <slot
        :name="activeTab"
        :showTab="showTab"
        :showNext="showNext"
        :showPrev="showPrev"
      ></slot>
    </div>
  </div>
</template>

<script>
import NeedsIcons from "../Mixins/NeedsIcons";

export default {
  mixins: [NeedsIcons],
  props: {
    tabs: {
      type: Object,
      required: true,
    },
    initialTab: {
      type: String,
      required: true,
    },
    navClass: {
      type: String,
    },
    buttonClass: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showNavIndices: {
      type: Boolean,
      default: false,
    },
    beforeSwitch: {
      type: Function,
    },
    onSwitch: {
      type: Function,
    },
  },
  computed: {
    tabsIndexed() {
      let tabsIndexed = [];

      Object.keys(this.tabsData).forEach((tabKey) => {
        if (tabKey in this.$slots || tabKey in this.$scopedSlots) {
          tabsIndexed.push({ key: tabKey, label: this.tabsData[tabKey] });
        }
      });

      return tabsIndexed;
    },
  },
  data() {
    return {
      activeTab: this.initialTab,
      tabsData: this.tabs,
      tabsVisited: [],
    };
  },
  watch: {
    initialTab: function (newTab) {
      this.tabsVisited.push(this.activeTab);
      this.activeTab = newTab;
    },
  },
  methods: {
    async showTab(keyOrIndex) {
      let key = keyOrIndex;
      let setTab = true;

      if (typeof keyOrIndex == "number") {
        let tabsIndexed = this.tabsIndexed;

        if (keyOrIndex > tabsIndexed.length - 1) {
          keyOrIndex = 0;
        }
        if (keyOrIndex < 0) {
          keyOrIndex = tabsIndexed.length - 1;
        }

        key = tabsIndexed[keyOrIndex].key;
      }

      if (this.beforeSwitch) {
        const result = await this.beforeSwitch(key);
        if (result === false) {
          return false;
        }
      }

      this.tabsVisited.push(this.activeTab);

      if (this.onSwitch) {
        setTab = await this.onSwitch(key);
      }

      if (setTab) {
        this.activeTab = key;

        Vue.nextTick(() => {
          this.$emit("switched", this);
        });
      }
      
      window.scrollTo(0,0);
    },
    showNext() {
      let currentIndex = this.tabsIndexed.findIndex(
        (t) => t.key === this.activeTab
      );

      this.showTab(currentIndex + 1);
    },
    showPrev() {
      let currentIndex = this.tabsIndexed.findIndex(
        (t) => t.key === this.activeTab
      );

      this.showTab(currentIndex - 1);
    },
  },
};
</script>